<template>
  <div class="flex gap-4 items-center text-sm">
    <div v-for="[index, element] of elements.entries()" :key="index" class="shrink-0">
      <router-link v-if="element.type === 'link'" :to="element.href" class="text-cta-600 cursor !font-normal">{{
        element.label
      }}</router-link>
      <span v-else-if="element.type === 'text'" class="text-neutral-950">{{ element.label }}</span>
      <v-icon
        v-else-if="element.type === 'separator'"
        name="chevron-right-solid"
        class="breadcrumb-chevron-icon-color"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, PropType } from 'vue';
import { VIcon } from '@vonage/vivid-vue';

interface BreadcrumbItem {
  title: string;
  href?: string;
}

const props = defineProps({
  items: {
    type: Array as PropType<BreadcrumbItem[]>,
    required: true,
  },
});

type Element =
  | {
      type: 'link';
      label: string;
      href: string;
    }
  | {
      type: 'text';
      label: string;
    }
  | {
      type: 'separator';
    };

const elements = computed(() => {
  const result: Element[] = [];
  for (const item of props.items) {
    if (result.length > 0) {
      result.push({ type: 'separator' });
    }
    if (item.href) {
      result.push({ type: 'link', label: item.title, href: item.href });
    } else {
      result.push({ type: 'text', label: item.title });
    }
  }
  return result;
});
</script>
<style scoped lang="scss">
span {
  font: var(--vvd-typography-base);
}
.breadcrumb-chevron-icon-color {
  color: var(--dev-docs-product-page-chevron-icon-color);
}
</style>
